import {duckify, singleDuck} from "../../utils/duckify";
import {customers} from "../../ducks";
import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import {entity as uploadFields} from '../../ducks/uploadFields';

class UploadedItem extends React.Component{
  static propTypes = {
    originalFilename: PropTypes.string.isRequired,
  };

  static defaultProps = {
    originalFilename: '',
  };

  constructor(){
    super();
  }

  render(){
    const { item, deleteItem } = this.props;
    const { original_filename } = item;

    return <div>
      <span className="upload-file-field-filename">
        { original_filename }
      </span>
      <span className="file-upload-button btn btn-sm fileinput-button">
        <span className="upload-item-delete btn btn-sm" data-bs-toggle="tooltip" title="Delete" onClick={()=>deleteItem(item)}>
          <FontAwesome name="trash-o"/>
        </span>
      </span>
    </div>
  }
}

function mapDucksToProps(ownProps){
  return {
    customer: singleDuck(customers, 'current')
  };
}

function mapStateToProps(state, ownProps){
  return {};
}

function mapDispatchToProps(dispatch, ownProps){
  const { field_name } = ownProps.item;
  return {
    deleteItem: (item) => dispatch(uploadFields.actions.remove(item))
      .then(() => dispatch(uploadFields.actions.markDirty(field_name)))
  }
}

export default (duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(UploadedItem));